import { render, staticRenderFns } from "./ElectricityStatistic.vue?vue&type=template&id=5ce85090&"
import script from "./ElectricityStatistic.vue?vue&type=script&lang=js&"
export * from "./ElectricityStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports